const ms = require('ms')
const fetch = require('@adc/fetch')
const configment = require('@adc/configment')

const domainEventsPayload = events => ({
  query: `
    mutation ${configment
      .get('APP_NAME')
      .replace(/-/g, '')}_instrument_domainEvents(
      $events: [DomainEvent!]!
    ) {
      domainEvents(events: $events)
    }
  `,
  variables: {
    events,
  },
})

const sendDomainEvents = events =>
  fetch.forAuctionGraph(domainEventsPayload(events), {
    requestTimeout: ms('2s'),
  })

const domainEvent = event => sendDomainEvents([event])

module.exports = {
  domainEventsPayload,
  sendDomainEvents,
  domainEvent,
}
